export const PROFILE_RESET_PASSWORD = 'PROFILE_RESET_PASSWORD'
export const UPDATE_EMERGENCY_CONTACT_PRESSED =
  'UPDATE_EMERGENCY_CONTACT_PRESSED'
export const UPDATE_MY_PHARMACY_PRESSED = 'UPDATE_MY_PHARMACY_PRESSED'
export const SEARCH_PHARMACY_CLEARED = 'SEARCH_PHARMACY_CLEARED'
export const UPDATE_MY_PHARMACY_PRESSED_FOR_OTHER_MEMBER =
  'UPDATE_MY_PHARMACY_PRESSED_FOR_OTHER_MEMBER'
export const UPLOAD_INVOICE_PRESSED = 'UPLOAD_INVOICE_PRESSED'

export const MY_COUPON_PRESSED = 'MY_COUPON_PRESSED'

export const CARE_TEAM_PRESSED = 'CARE_TEAM_PRESSED'
export const CONTACT_INFORMATION_PRESSED = 'CONTACT_INFORMATION_PRESSED'
export const SETTING_PREFERENCES_PRESSED = 'SETTING_PREFERENCES_PRESSED'
export const ACCOUNT_STATUS_PRESSED = 'ACCOUNT_STATUS_PRESSED'
export const UPDATE_GENDER_DETAILS_PRESSED = 'UPDATE_GENDER_DETAILS_PRESSED'

export const COMMUNICATION_PREFERENCES_PRESSED =
  'COMMUNICATION_PREFERENCES_PRESSED'
export const CHANGE_PASSWORD_PRESSED = 'CHANGE_PASSWORD_PRESSED'
export const LANGUAGE_PRESSED = 'LANGUAGE_PRESSED'
export const MVP_STATUS_PRESSED = 'MVP_STATUS_PRESSED'
export const OPEN_COMMUNICATION_PREFERENCES_CONFIGURE =
  'OPEN_COMMUNICATION_PREFERENCES_CONFIGURE'
export const FRONTEND_AUTHENTICATED_URLS_REQUESTED =
  'FRONTEND_AUTHENTICATED_URLS_REQUESTED'
export const FRONTEND_AUTHENTICATED_URLS_RECEIVED =
  'FRONTEND_AUTHENTICATED_URLS_RECEIVED'
export const MEMBERS_ACCUMULATORS_REQUESTED = 'MEMBERS_ACCUMULATORS_REQUESTED'
export const MEMBERS_ACCUMULATORS_RECEIVED = 'MEMBERS_ACCUMULATORS_RECEIVED'
export const MEMBERS_ACCUMULATORS_FAILED = 'MEMBERS_ACCUMULATORS_FAILED'
